export default __webpack_public_path__ + "static/Ammo_Box-9d1d66832fa4549a97f8771240e68fcb.png";